<template>
  <div class="index-carousel-wrap">
    <TitleCard :titles="titles"
               :showMore="false"
               isSwitch
               @switchTitle="switchTitleHandle"
               :defaultSelected="defaultId">
      <div class="index-carousel-item-wrap">
        <Collapse :options="trainingList.list"
                  @toDetail="toDetaila"
                  @toMore="toMore"
                  v-if="trainingList.list && trainingList.list.length>0"></Collapse>
        <div class="noData"
             v-else>
          <img src="../../../../public/static/nodata.png"
               alt="" />
        </div>
        <Carousel @picChange="toPicDetail"
                  :picture="trainingList.list"
                  v-if="trainingList.list && trainingList.list.length>0"></Carousel>
        <div class="noDataImg"
             v-else>
          <img src="../../../../public/static/noImg.png"
               alt="" />
        </div>
      </div>
    </TitleCard>
  </div>
</template>

<script>
import Carousel from '@/components/common/Carousel.vue'
import Collapse from '@/components/common/Collapse.vue'
import { activityList, competeList } from '../configs/config'
import { mapGetters } from 'vuex'

export default {
  props: {
    name: String,
    trainingList: Object,
    titles: Array,
    defaultId: Number || String
  },
  data() {
    return {
      activityList,
      competeList,
      selectId: ''
    }
  },
  components: {
    Carousel,
    Collapse
  },
  computed: {
    ...mapGetters('headerMenu', ['setUpdateMenuList']),
    menuList() {
      return this.setUpdateMenuList
    }
  },
  watch: {
    titles: {
      handler(val) {
        if (val?.length) {
          this.defaultId = val[0].id
        }
      }
    },
    immediate: true,
    deep: true
  },
  methods: {
    switchTitleHandle({ id, name }) {
      this.$emit('switchTitleInformation', { id, name })
    },
    // 处理手风琴item项的跳转逻辑
    toDetaila(item) {
      this.$emit('handleDetail', item)
    },
    // 处理点击轮播图的跳转逻辑
    toPicDetail(item) {
      this.$emit('handleDetail', item)
    },
    // 点击更多跳转跳转到列表页
    toMore() {
      if (this.name === '素养教育') {
        this.$router.push({
          path: '/informationService',
          query: {
            code: 'xinxiServer',
            selectedId: this.commonHandle('xinxiServer', 'trainingLectures')
          }
        })
      } else {
        this.$router.push({
          path: '/informationService',
          query: {
            code: 'xinxiServer',
            selectedId: this.commonHandle('xinxiServer', 'competitionDynamics')
          }
        })
      }
    },
    commonHandle(codeOne, codeTwo) {
      let obj = this.menuList.filter((res) => res.code === codeOne)
      let selectedId
      obj[0].children.forEach((res) => {
        if (res.code === codeTwo) {
          selectedId = res.id
        }
      })
      return selectedId
    }
  }
}
</script>

<style></style>
